<div class="card" matRipple (click)="activityEventClicked()" [class.missed]="cardType === 'StopEventInfo' && info?.missed === true" [class.active]="isActive" >
  @switch (cardType) {
    @case ('StopEventInfo') {
      <div class="header">
        <div class="title">
          <span class="smaller">({{info?.sequenceNumber}})</span> {{ info?.title }}
          @if (info?.platformCode) {
            ({{info?.platformCode}})
          }
        </div>
        @if (info?.isTimingPoint) {
          <i class="far fa-clock"></i>
        }
      </div>
      <div class="properties">
        <div class="property">
          <span translate>Arrival</span>
          <span matRipple (mousedown)="$event.stopPropagation()" (click)="timestampClick(info?.observedArrivalTs); $event.stopPropagation()">{{info?.observedArrival | amDateFormat: 'HH:mm:ss'}}</span>
        </div>
        <div class="property justify-content-center">
          @if (info?.observedArrival) {
            <div class="deviation" [ngStyle]="{'background-color': info?.deviation.arrival?.color}">
              {{ info?.arrivalDeviation?.toShortString() }}
              ({{info?.deviation.arrival?.text | translate}})
            </div>
          }
        </div>
        <div class="property">
          <span translate>Planned</span>
          <span>{{info?.plannedArrival | amDateFormat: 'HH:mm:ss'}} </span>
        </div>
        <div class="property">
          <span translate>Departure</span>
          <span matRipple (mousedown)="$event.stopPropagation()" (click)="timestampClick(info?.observedDepartureTs); $event.stopPropagation()">{{info?.observedDeparture | amDateFormat: 'HH:mm:ss'}}</span>
        </div>
        <div class="property justify-content-center">
          @if (info?.observedDeparture) {
            <div class="deviation" [ngStyle]="{'background-color': info?.deviation.departure?.color}">
              {{ info?.departureDeviation?.toShortString() }}
              ({{info?.deviation.departure?.text| translate}})
            </div>
          }
        </div>
        <div class="property">
          <span translate>Planned</span>
          <span>{{info?.plannedDeparture | amDateFormat: 'HH:mm:ss'}} </span>
        </div>
      </div>
      @if (info?.events?.length > 0) {
        <div class="additional-footer-info">
          <div class="properties">
            @for (event of info?.events; track event.selectorId || $index) {
              @switch (event.type) {
                @case ('DoorHistory') {
                  <ng-container *ngTemplateOutlet="doorHistoryTemplate;context:{door:event}">
                  </ng-container>
                }
              }
            }
          </div>
        </div>
      }
    }
    @case ('DoorHistory') {
      <div class="properties">
        <ng-container *ngTemplateOutlet="doorHistoryTemplate;context:{door:info}">
        </ng-container>
      </div>
    }
    @case ('OffRouteEvent') {
      <div class="header">
        <i class="fas fa-route" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;
        @if (info?.eventType === 'OffRoute') {
          <div class="title">{{ 'Vehicle is off route' | translate }}</div>
        }
        @if (info?.eventType === 'BackOnRoute') {
          <div class="title">{{ 'Vehicle is back on route' | translate }}</div>
        }
        <div class="properties">
          <div class="property">
            <span>{{info?.timestamp | amDateFormat: 'HH:mm:ss'}} </span>
          </div>
        </div>
      </div>
    }
    @default {
      <div class="header">
        <div class="title">{{ info?.title }}</div>
      </div>
      <div class="properties">
        <div class="property">
          {{ info?.description }}
        </div>
      </div>
    }
  }
</div>

<!-- common templates -->
<ng-template #doorHistoryTemplate let-door='door'>
  <div class="property flex-basis-half justify-content-start">
    @if (door?.isOpen) {
      <i class="icon fas fa-door-open"></i> {{ 'Doors open' | translate}}
    } @else {
      <i class="icon fas fa-door-closed"></i> {{ 'Doors closed' | translate}}
    }
  </div>
  <div class="property flex-basis-half justify-content-end">
    <div matRipple (mousedown)="$event.stopPropagation()" (click)="eventClick(door); $event.stopPropagation()">{{ door?.description }}</div>
  </div>
</ng-template>
